if (!customElements.get('code-product-atc')) {
customElements.define(
  'code-product-atc',
  class CodeProductAtc extends HTMLElement {
    connectedCallback() {
      const {
        formMain: [formMain],
        formUpdate: [formUpdate],
        quantitySelector: [quantitySelector],
        quantityInput: [quantityInput],
        addFullBox: [addFullBox] = [],
      } = codeGetTargets(this);

      const submit = async (form, variantId, quantity = 1, direction = 1) => {
        if (!form || !variantId) return;

        const {
          formMain: [formMain],
          errors: [errors],
        } = codeGetTargets(this);

        const query = `?variant=${variantId}`;
        const formData = new FormData(form);
        formData.append(
          'sections',
          this.hasAttribute('data-main-cart') ? ['main-cart'] : ['cart-drawer', 'main-product'],
        );
        formData.append('sections_url', `${window.location.pathname}${query}`);
        formData.append('id', variantId);
        formData.append('quantity', quantity);

        try {
          form.toggleAttribute('data-loading', true);
          errors.textContent = '';
          errors.toggleAttribute('data-active', false);

          let response;
          if (form === formMain) {
            response = await fetch(routes.cart_add_url, {
              method: 'POST',
              body: formData,
              headers: {
                'X-Requested-With': 'XMLHttpRequest',
                Accept: 'application/json',
              },
            });
          } else {
            response = await fetch(routes.cart_change_url, {
              method: 'POST',
              body: formData,
              headers: {
                'X-Requested-With': 'XMLHttpRequest',
                Accept: 'application/json',
              },
            });
          }

          const responseData = await response?.json();
          if (responseData?.errors) {
            errors.textContent = responseData.errors;
            errors.toggleAttribute('data-active', true);
          } else {
            const cartResponse = await fetch(routes.cart_url, {
              method: 'GET',
              headers: {
                'X-Requested-With': 'XMLHttpRequest',
                Accept: 'application/json',
              },
            });

            const cartData = await cartResponse.json();
            publish('cartUpdate', { ...cartData, sections: responseData.sections, direction, variantId });
            klaviyoTrackEvent(cartData);
          }
        } catch (error) {
          console.error('Error processing form submission:', error);
        } finally {
          form.toggleAttribute('data-loading', false);
        }
      };

      const klaviyoTrackEvent = (cartData) => {
        const klaviyo = window.klaviyo || [];
        const cart = {
          total_price: cartData.total_price / 100,
          $value: cartData.total_price / 100,
          total_discount: cartData.total_discount,
          original_total_price: cartData.original_total_price / 100,
          items: cartData.items,
        };

        klaviyo.push(['track', 'Added to Cart', cart]);
      };

      formMain?.addEventListener('submit', (event) => {
        formMain.toggleAttribute('data-active', false);
        formUpdate.toggleAttribute('data-active', true);
        quantitySelector.toggleAttribute('data-active', true);

        event.preventDefault();
        submit(formMain, parseInt(formMain.elements['id'].value), parseInt(formMain.elements['quantity'].value));
      });

      formUpdate.addEventListener('submit', (event) => {
        event.preventDefault();
      });

      addFullBox?.addEventListener('click', (event) => {
        event.preventDefault();
        submit(formMain, parseInt(addFullBox.dataset.id), parseInt(addFullBox.dataset.quantity));
      });

      this.subscribeUpdateQuantity = subscribe('updateQuantity', ({ variantId, quantity, direction }) => {
        if (!variantId && !quantity) return;
        if (parseInt(this.dataset.variantId) !== variantId) return;
        if (formUpdate.id.includes('desktop') && window.innerWidth < 768) return;
        submit(formUpdate, variantId, quantity, direction);

        if (quantity == 0) {
          formMain.toggleAttribute('data-active', true);
          formUpdate.toggleAttribute('data-active', false);
          quantitySelector.toggleAttribute('data-active', false);
          quantityInput.toggleAttribute('data-active', false);
        }

        if (quantity > 0) {
          formMain.toggleAttribute('data-active', false);
          formUpdate.toggleAttribute('data-active', true);
          quantitySelector.toggleAttribute('data-active', true);
          quantityInput.toggleAttribute('data-active', false);
        }
      });

      this.subscribeUpdateProductQuantityInputVisibility = subscribe(
        'updateProductQuantityInputVisibility',
        ({ variantId }) => {
          if (parseInt(this.dataset.variantId) !== variantId) return;

          formMain.toggleAttribute('data-active', false);
          formUpdate.toggleAttribute('data-active', true);
          quantitySelector.toggleAttribute('data-active', false);
          quantityInput.toggleAttribute('data-active', true);
        },
      );

      this.subscribeCartUpdate = subscribe('cartUpdate', (cart) => {
        if (cart.items.find((item) => item.variant_id === parseInt(this.dataset.variantId))) {
          formMain.toggleAttribute('data-active', false);
          formUpdate.toggleAttribute('data-active', true);
          quantitySelector.toggleAttribute('data-active', true);
          quantityInput.toggleAttribute('data-active', false);
        } else {
          if (!formMain.dataset.active) {
            formMain.toggleAttribute('data-active', true);
            formUpdate.toggleAttribute('data-active', false);
            quantitySelector.toggleAttribute('data-active', false);
            quantityInput.toggleAttribute('data-active', false);
          }
        }
      });
    }

    disconnectedCallback() {
      this.subscribeUpdateQuantity();
      this.subscribeUpdateProductQuantityInputVisibility();
      this.subscribeCartUpdate();
    }
  },
);
}
